'use strict';

var toConsumableArray = require('../../node_modules/@babel/runtime/helpers/toConsumableArray.js');
var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var blobUtil_es = require('../../node_modules/blob-util/dist/blob-util.es.js');
var React = require('react');
require('prop-types');
var CropImageDialog = require('./CropImageDialog.js');
var ImageUploadButton = require('./ImageUploadButton.js');
var ImageCarousel = require('./ImageCarousel.js');
var Grid = require('../../node_modules/@material-ui/core/esm/Grid/Grid.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ImageCarouselWithNewImageCropper =
/*#__PURE__*/
function (_PureComponent) {
  inherits(ImageCarouselWithNewImageCropper, _PureComponent);

  function ImageCarouselWithNewImageCropper(props) {
    var _this;

    classCallCheck(this, ImageCarouselWithNewImageCropper);

    _this = possibleConstructorReturn(this, getPrototypeOf(ImageCarouselWithNewImageCropper).call(this, props));
    _this.state = {
      selectedIndex: 0,
      showCropperDialog: false,
      uploadImage: props.currentSelectedImage.original_url,
      selectDefault: false,
      updatedImageList: props.defaultIndustryPhotos
    };
    return _this;
  }

  createClass(ImageCarouselWithNewImageCropper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var checked = this.checkDefault(this.props.currentSelectedImage);
      this.setState({
        selectedIndex: checked.index,
        selectDefault: checked.isDefault,
        updatedImageList: checked.updatedImageList
      });
    }
  }, {
    key: "checkDefault",
    value: function checkDefault(currentSelectedImage) {
      var url = currentSelectedImage.original_url;
      var fileName = !!url ? url.substring(url.lastIndexOf('/'), url.lastIndexOf('.')) : 'image';
      var defaultIndustryPhotos = this.props.defaultIndustryPhotos;

      for (var index in defaultIndustryPhotos) {
        if (defaultIndustryPhotos[index].original_url.includes(fileName)) {
          return {
            isDefault: true,
            index: Number(index),
            updatedImageList: this.props.defaultIndustryPhotos
          };
        }
      }

      return {
        isDefault: false,
        index: 0,
        updatedImageList: [currentSelectedImage].concat(toConsumableArray(defaultIndustryPhotos))
      };
    }
  }, {
    key: "combineImages",
    value: function combineImages(currentSelectedImage) {
      var combinedImagesList = this.props.defaultIndustryPhotos;

      if (!this.state.selectDefault && currentSelectedImage) {
        combinedImagesList = [currentSelectedImage].concat(toConsumableArray(combinedImagesList));
      }

      return combinedImagesList;
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(index) {
      this.props.onSelectImage(this.state.updatedImageList[index]);
      this.setState({
        selectedIndex: index
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          aspectRatio = _this$props.aspectRatio,
          currentSelectedImage = _this$props.currentSelectedImage;
      var _this$state = this.state,
          selectedIndex = _this$state.selectedIndex,
          showCropperDialog = _this$state.showCropperDialog;
      return React__default["default"].createElement(Grid["default"], {
        container: true
      }, React__default["default"].createElement(Grid["default"], {
        item: true,
        xs: 12
      }, React__default["default"].createElement(ImageCarousel, {
        aspectRatio: aspectRatio,
        imageUrlList: this.combineImages(currentSelectedImage),
        startIndex: selectedIndex,
        onSelect: function onSelect(event, index) {
          _this2.handleSelect(index);
        },
        onSelectBullet: function onSelectBullet(_ref) {
          _ref.item;
              var itemIndex = _ref.itemIndex;
              _ref.currentIndex;

          _this2.handleSelect(itemIndex);
        }
      })), React__default["default"].createElement(Grid["default"], {
        item: true
      }, React__default["default"].createElement(ImageUploadButton, {
        handlePhotoUpload: function handlePhotoUpload(event) {
          _this2.setState({
            showCropperDialog: true,
            uploadImage: URL.createObjectURL(event.target.files[0])
          });
        }
      })), React__default["default"].createElement(CropImageDialog, {
        open: showCropperDialog,
        imageUrl: this.state.uploadImage,
        aspectRatio: aspectRatio,
        onClose: function onClose() {
          return _this2.setState({
            showCropperDialog: false
          });
        },
        onSaveCroppedImage: function onSaveCroppedImage(blob) {
          blobUtil_es.imgSrcToBlob(_this2.state.uploadImage).then(function (originalImageBlob) {
            return _this2.props.onSaveCroppedImage(blob, originalImageBlob);
          })["catch"](function () {
            return _this2.props.onSaveCroppedImage(blob);
          })["finally"](function () {
            _this2.setState({
              showCropperDialog: false,
              selectedIndex: 0,
              selectDefault: false
            });
          });
        }
      }));
    }
  }]);

  return ImageCarouselWithNewImageCropper;
}(React.PureComponent);
ImageCarouselWithNewImageCropper.defaultProps = {
  defaultIndustryPhotos: [],
  currentSelectedImage: {}
};

module.exports = ImageCarouselWithNewImageCropper;
